import { render } from "./AtividadeFiltroDialog.vue?vue&type=template&id=e668ccb2"
import script from "./AtividadeFiltroDialog.vue?vue&type=script&lang=js"
export * from "./AtividadeFiltroDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__